import React from "react"

export interface SelectOption {
    value: string;
    label: string;
    disabled?: boolean;
}

interface SelectInputProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
    label?: string,
    message?: string,
    options: SelectOption[];
    placeholder?: string;
    touched?: boolean,
    error?: boolean,
    inputClassName?: string
}


const SelectInput: React.FC<SelectInputProps> = ({
    label,
    message,
    options,
    placeholder,
    required,
    error,
    name,
    className,
    inputClassName,
    ...selectProps
}) => {
    return (
        <div className={`input-container ${error ? 'error' : ''} ${className ?? ''}`}>
            {label && <span className="input-label">{label}{required && '*'}</span>}
            <select className={`input ${inputClassName}`}{...selectProps} required={required} name={name}>
                {placeholder && <option value="" disabled>{placeholder}</option>}
                {options.map((option) => (
                    <option key={option.value} value={option.value} disabled={option.disabled ?? false}>
                        {option.label}
                    </option>
                ))}
            </select>
            {message && <span className="input-message">{message}</span>}
        </div>
    )
}

export default SelectInput